import { render, staticRenderFns } from "./SurveyLinkIsExpired.vue?vue&type=template&id=31ce6380&scoped=true&"
import script from "./SurveyLinkIsExpired.vue?vue&type=script&lang=js&"
export * from "./SurveyLinkIsExpired.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLinkIsExpired.vue?vue&type=style&index=0&id=31ce6380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce6380",
  null
  
)

export default component.exports